import { connect } from 'react-redux';
import ScribeWordInput from './ScribeWordInput';
import {
  highlightTranscript,
  insertUpdateMutation,
  scribeDeselectTranscriptWord,
  scribeJumpToBlocEnd,
  scribeJumpToBlocStart,
  scribeJumpToNextBloc,
  scribeJumpToNextHightlightedBloc,
  scribeJumpToPreviousBloc,
  scribeMultiSelectLeft,
  scribeMultiSelectRight,
  scribeSelectTranscriptWord,
  scribeUpdateInputValue,
  scribeWordEditSetStarted,
} from '../../actions';

const mapStateToProps = state => {
  const {
    scribeConversation: {
      conversationEnded,
      ui: {
        selectedWordInputValue,
        selectedTranscriptIndex,
        selectedTranscriptCaretPosition,
        selectedWordIndex,
        wordBeingEdited,
        selectionLength,
      },
    },
  } = state;
  return {
    conversationEnded,
    selectedWordInputValue,
    selectedWordIndex,
    selectedTranscriptCaretPosition,
    wordBeingEdited,
    selectedTranscriptIndex,
    selectionLength,
  };
};

export default connect(mapStateToProps, {
  highlightTranscript,
  insertUpdateMutation,
  scribeDeselectTranscriptWord,
  scribeJumpToBlocEnd,
  scribeJumpToBlocStart,
  scribeJumpToNextBloc,
  scribeJumpToNextHightlightedBloc,
  scribeJumpToPreviousBloc,
  scribeMultiSelectLeft,
  scribeMultiSelectRight,
  scribeSelectTranscriptWord,
  scribeUpdateInputValue,
  scribeWordEditSetStarted,
})(ScribeWordInput);
